export class NumberUtils {
  static formatDecimalToPercent = (
    decimal: string | number | null | undefined,
    options?: { decimalPoint?: number; omitSuffix?: boolean },
  ): string => {
    if (decimal === null || decimal === undefined) {
      return '';
    }

    const decimalPoint = options?.decimalPoint ?? 0;

    try {
      const n = typeof decimal === 'string' ? parseFloat(decimal) : decimal;
      const s = Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimalPoint,
        maximumFractionDigits: decimalPoint,
      }).format(n * 100);
      return `${s}${(options?.omitSuffix ?? true) ? '' : '%'}`;
    } catch (_error) {
      return 'N/A';
    }
  };

  static ordinalSuffix = (n: number): string => {
    try {
      const s = ['th', 'st', 'nd', 'rd'];
      const v = n % 100;
      return s[(v - 20) % 10] || s[v] || s[0];
    } catch (_error) {
      return '';
    }
  };

  static isNumber(value: unknown, allowEmptyString = false): value is number {
    try {
      const isNumOrStr = typeof value === 'number' || typeof value === 'string';

      if (!isNumOrStr) {
        return false;
      }

      const trimmedValue = value.toString().trim();

      if (!allowEmptyString && trimmedValue === '') {
        return false;
      }

      return !Number.isNaN(Number(value.toString()));
    } catch (_error) {
      return false;
    }
  }

  static format = (number: number | bigint | string | null | undefined, options?: Intl.NumberFormatOptions): string => {
    if (typeof number === 'undefined' || number === null) {
      return '';
    }

    try {
      return new Intl.NumberFormat('en-US', { ...options, useGrouping: options?.useGrouping ?? 'always' }).format(
        Number(number),
      );
    } catch (_error) {
      return number.toString();
    }
  };
}
